import { Card } from '@getdokan/dokan-ui';
import { __ } from '@wordpress/i18n';
import { twMerge } from 'tailwind-merge';

function Skeleton() {
    const loader = twMerge(
        'text-transparent bg-neutral-200 animate-pulse rounded'
    );

    return (
        <div className="flex flex-col-reverse md:flex-row md:justify-between gap-4">
            <div className="md:w-3/4">
                <Card className="bg-white rounded-md shadow-md">
                    <div className="border-b-2 p-4">
                        <h2
                            className={ twMerge( 'font-bold text-lg', loader ) }
                        >
                            -
                        </h2>
                    </div>

                    <div className="flex flex-col w-full h-[600px] overflow-auto border-b-2 p-4">
                        <div className="p-4 border-b flex flex-col gap-4">
                            <div className="flex gap-4">
                                <div
                                    className={ twMerge(
                                        'w-[44px] h-[44px] rounded-full',
                                        loader
                                    ) }
                                ></div>
                                <div className="flex gap-1 flex-col">
                                    <span
                                        className={ twMerge(
                                            'font-bold text-sm',
                                            loader
                                        ) }
                                    >
                                        ------------
                                    </span>
                                    <span className={ loader }>
                                        ----------------------
                                    </span>
                                </div>
                            </div>
                            <div className={ twMerge( 'h-44', loader ) }></div>
                        </div>
                        <div className="p-4 border-b flex flex-col gap-4">
                            <div className="flex gap-4">
                                <div
                                    className={ twMerge(
                                        'w-[44px] h-[44px] rounded-full',
                                        loader
                                    ) }
                                ></div>
                                <div className="flex gap-1 flex-col">
                                    <span
                                        className={ twMerge(
                                            'font-bold text-sm',
                                            loader
                                        ) }
                                    >
                                        -------------
                                    </span>
                                    <span className={ loader }>
                                        ----------------------
                                    </span>
                                </div>
                            </div>
                            <div className={ twMerge( 'h-44', loader ) }></div>
                        </div>
                        <div className="p-4 border-b flex flex-col gap-4">
                            <div className="flex gap-4">
                                <div
                                    className={ twMerge(
                                        'w-[44px] h-[44px] rounded-full',
                                        loader
                                    ) }
                                ></div>
                                <div className="flex gap-1 flex-col">
                                    <span
                                        className={ twMerge(
                                            'font-bold text-sm',
                                            loader
                                        ) }
                                    >
                                        -------------
                                    </span>
                                    <span className={ loader }>
                                        ----------------------
                                    </span>
                                </div>
                            </div>
                            <div className={ twMerge( 'h-44', loader ) }></div>
                        </div>
                        <div className="p-4 border-b flex flex-col gap-4">
                            <div className="flex gap-4">
                                <div
                                    className={ twMerge(
                                        'w-[44px] h-[44px] rounded-full',
                                        loader
                                    ) }
                                ></div>
                                <div className="flex gap-1 flex-col">
                                    <span
                                        className={ twMerge(
                                            'font-bold text-sm',
                                            loader
                                        ) }
                                    >
                                        -------------
                                    </span>
                                    <span className={ loader }>
                                        ----------------------
                                    </span>
                                </div>
                            </div>
                            <div className={ twMerge( 'h-44', loader ) }></div>
                        </div>
                        <div className="p-4 border-b flex flex-col gap-4">
                            <div className="flex gap-4">
                                <div
                                    className={ twMerge(
                                        'w-[44px] h-[44px] rounded-full',
                                        loader
                                    ) }
                                ></div>
                                <div className="flex gap-1 flex-col">
                                    <span
                                        className={ twMerge(
                                            'font-bold text-sm',
                                            loader
                                        ) }
                                    >
                                        ------------
                                    </span>
                                    <span className={ loader }>
                                        ----------------------
                                    </span>
                                </div>
                            </div>
                            <div className={ twMerge( 'h-44', loader ) }></div>
                        </div>
                        <div className="p-4 border-b flex flex-col gap-4">
                            <div className="flex gap-4">
                                <div
                                    className={ twMerge(
                                        'w-[44px] h-[44px] rounded-full',
                                        loader
                                    ) }
                                ></div>
                                <div className="flex gap-1 flex-col">
                                    <span
                                        className={ twMerge(
                                            'font-bold text-sm',
                                            loader
                                        ) }
                                    >
                                        ------------
                                    </span>
                                    <span className={ loader }>
                                        ----------------------
                                    </span>
                                </div>
                            </div>
                            <div className={ twMerge( 'h-44', loader ) }></div>
                        </div>
                        <div className="p-4 border-b flex flex-col gap-4">
                            <div className="flex gap-4">
                                <div
                                    className={ twMerge(
                                        'w-[44px] h-[44px] rounded-full',
                                        loader
                                    ) }
                                ></div>
                                <div className="flex gap-1 flex-col">
                                    <span
                                        className={ twMerge(
                                            'font-bold text-sm',
                                            loader
                                        ) }
                                    >
                                        ------------
                                    </span>
                                    <span className={ loader }>
                                        ----------------------
                                    </span>
                                </div>
                            </div>
                            <div className={ twMerge( 'h-44', loader ) }></div>
                        </div>
                        <div className="p-4 border-b flex flex-col gap-4">
                            <div className="flex gap-4">
                                <div
                                    className={ twMerge(
                                        'w-[44px] h-[44px] rounded-full',
                                        loader
                                    ) }
                                ></div>
                                <div className="flex gap-1 flex-col">
                                    <span
                                        className={ twMerge(
                                            'font-bold text-sm',
                                            loader
                                        ) }
                                    >
                                        -----------
                                    </span>
                                    <span className={ loader }>
                                        -----------------------
                                    </span>
                                </div>
                            </div>
                            <div className={ twMerge( 'h-44', loader ) }></div>
                        </div>
                    </div>

                    <div className="p-4">
                        <div
                            className={ twMerge( 'h-52 w-full', loader ) }
                        ></div>

                        <div
                            className={ twMerge(
                                'h-[30px] w-[100px] rounded mt-4',
                                loader
                            ) }
                        ></div>
                    </div>
                </Card>
            </div>
            <div className="md:w-1/4">
                <Card className="bg-white rounded-md shadow-md">
                    <div className="border-b w-full h-auto p-4 flex flex-col justify-center items-center gap-4">
                        <div
                            className={ twMerge(
                                'w-[106px] h-[106px] rounded-full overflow-hidden',
                                loader
                            ) }
                        ></div>
                        <h2
                            className={ twMerge( 'font-bold text-lg', loader ) }
                        >
                            -------------------
                        </h2>
                    </div>
                    <div className="border-b p-4 flex flex-col gap-2">
                        <span className="flex flex-row">
                            <span
                                className={ twMerge( 'font-semibold', loader ) }
                            >
                                { __( 'Email:', 'dokan' ) }
                            </span>
                            <span
                                className={ twMerge(
                                    'ml-1',
                                    loader
                                ) }
                            >
                                ------------------
                            </span>
                        </span>

                        <span className="flex flex-row">
                            <span
                                className={ twMerge( 'font-semibold', loader ) }
                            >
                                { __( 'Conversations:', 'dokan' ) }
                            </span>
                            <span className={ twMerge( 'ml-1', loader ) }>
                                10
                            </span>
                        </span>

                        <span className="flex flex-row">
                            <span
                                className={ twMerge( 'font-semibold', loader ) }
                            >
                                { __( 'Local time:', 'dokan' ) }
                            </span>
                            <span
                                className={ twMerge(
                                    'ml-1',
                                    loader
                                ) }
                            >
                                -------------------
                            </span>
                        </span>
                    </div>
                    <div className="flex flex-col gap-4 items-end p-4">
                        <div
                            className={ twMerge( 'w-full h-9', loader ) }
                        ></div>
                        <div
                            className={ twMerge(
                                'h-[30px] w-[100px] rounded',
                                loader
                            ) }
                        ></div>
                    </div>
                </Card>
            </div>
        </div>
    );
}

export default Skeleton;
